/**
 * @generated SignedSource<<14bed6ae5208842062ed15ce7f530297>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpObjectStoreSearchAlgorithm = "KEYWORD_SEARCH_ON_ISSUES" | "KEYWORD_SEARCH_ON_PORTALS_BM25" | "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH" | "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25" | "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH" | "%future added value";
export type HelpObjectStoreSearchBackend = "JIRA" | "SEARCH_PLATFORM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type requestFormItemFragment$data = {
  readonly __typename: "HelpObjectStoreSearchResult";
  readonly displayLink: string;
  readonly id: string;
  readonly isExternal: boolean;
  readonly searchAlgorithm: HelpObjectStoreSearchAlgorithm | null;
  readonly searchBackend: HelpObjectStoreSearchBackend | null;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"resourceIconFragment">;
  readonly " $fragmentType": "requestFormItemFragment";
};
export type requestFormItemFragment$key = {
  readonly " $data"?: requestFormItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestFormItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "requestFormItemFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "__typename"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "title"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "displayLink"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isExternal"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "searchBackend"
    },
    {
      "kind": "ScalarField",
      "name": "searchAlgorithm"
    },
    {
      "kind": "FragmentSpread",
      "name": "resourceIconFragment"
    }
  ],
  "type": "HelpObjectStoreSearchResult"
};

(node as any).hash = "10cdab9f2a7c89157e22f583e930228c";

export default node;
